import gql from "graphql-tag";

export const addProduit = gql`
  mutation addProduit(
    $planId: Int!
    $categorieId: Int!
    $produitName: String!
  ) {
    addProduit(
      planId: $planId
      categorieId: $categorieId
      produitName: $produitName
    ) {
      type
      message
      details
    }
  }
`;

export const renameProduit = gql`
  mutation renameProduit(
    $planId: Int!
    $categorieId: Int!
    $produitId: Int!
    $produitNewName: String!
  ) {
    renameProduit(
      planId: $planId
      categorieId: $categorieId
      produitId: $produitId
      produitNewName: $produitNewName
    ) {
      type
      message
      details
    }
  }
`;

export const removeProduit = gql`
  mutation removeProduit($planId: Int!, $categorieId: Int!, $produitId: Int!) {
    removeProduit(
      planId: $planId
      categorieId: $categorieId
      produitId: $produitId
    ) {
      type
      message
      details
    }
  }
`;

export const addCategorie = gql`
  mutation addCategorie(
    $planId: Int!
    $categorieName: String!
    $profit: Boolean
  ) {
    addCategorie(
      planId: $planId
      categorieName: $categorieName
      profit: $profit
    ) {
      type
      message
      details
    }
  }
`;

export const renameCategorie = gql`
  mutation renameCategorie(
    $planId: Int!
    $categorieId: Int!
    $categorieNewName: String!
  ) {
    renameCategorie(
      planId: $planId
      categorieId: $categorieId
      categorieNewName: $categorieNewName
    ) {
      type
      message
      details
    }
  }
`;

export const removeCategorie = gql`
  mutation removeCategorie($planId: Int!, $categorieId: Int!) {
    removeCategorie(planId: $planId, categorieId: $categorieId) {
      type
      message
      details
    }
  }
`;
